import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Mascot } from "@/components/Mascot";
import { Button } from "@/components/ui/button";
import { Header } from "@/components/layout/Header";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-dvh flex flex-col">
      <Header />
      <div className="flex flex-1 items-center justify-center gradient-warm">
        <div className="text-center px-4">
          <Mascot mood="confused" size="xl" className="mx-auto mb-6" />
          <h1 className="font-display text-6xl font-bold text-foreground mb-2">404</h1>
          <p className="text-xl text-muted-foreground mb-6">
            Looks like this page got a little ungrounded. Let's get you back.
          </p>
          <Link to="/">
            <Button className="btn-cozy text-primary-foreground gap-2">
              <Home className="h-4 w-4" />
              Return to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
